module.exports = __webpack_public_path__ + "fonts/Lato-Bold.cccb8974.woff2";